import { supabase } from '../../utils/supabaseClient';

export async function getProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  if (error && error.code !== 'PGRST116') throw error; // not found
  return data || null;
}

/**
 * Get next available BNxxx ID by counting existing profiles.
 * @returns {Promise<string>} - Next sequential BN ID (e.g., 'BN001')
 */
export async function getNextBNId() {
  const { count, error } = await supabase
    .from('profiles')
    .select('*', { count: 'exact', head: true });
  
  if (error) throw error;
  
  const nextNumber = (count || 0) + 1;
  return `BN${nextNumber.toString().padStart(3, '0')}`;
}

export async function upsertProfile(userId, values) {
  // First, fetch existing data to ensure we don't overwrite fields with null
  let existingData = {};
  try {
    const { data } = await supabase.from('profiles').select('*').eq('id', userId).single();
    if (data) existingData = data;
  } catch (e) {
    // ignore error, assume new profile
  }

  const payload = {
    id: userId,
    business_name: values.businessName !== undefined ? values.businessName : (existingData.business_name || null),
    username: values.username !== undefined ? values.username : (existingData.username || null),
    franchise_name: values.franchiseName !== undefined ? values.franchiseName : (existingData.franchise_name || values.businessName || existingData.business_name || null),
    gst_no: values.gstNo !== undefined ? values.gstNo : (existingData.gst_no || null),
    pan_no: values.panNo !== undefined ? values.panNo : (existingData.pan_no || null),
    address: values.address !== undefined ? values.address : (existingData.address || null),
    email: values.email !== undefined ? values.email : (existingData.email || null),
    mobile_no: values.mobileNo !== undefined ? values.mobileNo : (existingData.mobile_no || null),
    bank_name: values.bankName !== undefined ? values.bankName : (existingData.bank_name || null),
    account_no: values.accountNo !== undefined ? values.accountNo : (existingData.account_no || null),
    ifsc: values.ifsc !== undefined ? values.ifsc : (existingData.ifsc || null),
    branch_name: values.branchName !== undefined ? values.branchName : (existingData.branch_name || null),
    terms: values.terms !== undefined ? values.terms : (existingData.terms || null),
    logo_url: values.logoUrl !== undefined ? values.logoUrl : (existingData.logo_url || null),
    invoice_prefix: values.invoicePrefix !== undefined ? values.invoicePrefix : (existingData.invoice_prefix || null),
    hsn_sac: values.hsnSac !== undefined ? values.hsnSac : (existingData.hsn_sac || null),
    modes: values.modes !== undefined ? values.modes : (existingData.modes || null),
    products: values.products !== undefined ? values.products : (existingData.products || null),
    sectors: values.sectors !== undefined ? values.sectors : (existingData.sectors || null),
    updated_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from('profiles')
    .upsert(payload, { onConflict: 'id' })
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function uploadLogo(file) {
  const fileExt = file.name.split('.').pop();
  const fileName = `${crypto.randomUUID()}.${fileExt}`;
  const filePath = `logos/${fileName}`;

  const { error } = await supabase
    .from('logos')
    .upload(filePath, file, { upsert: false, cacheControl: '3600' });
  if (error) throw error;

  // Make sure we're getting the public URL correctly
  const { data: urlData } = supabase.storage.from('logos').getPublicUrl(filePath);
  console.log('Logo upload successful:', { path: filePath, publicUrl: urlData.publicUrl });
  return { path: filePath, publicUrl: urlData.publicUrl };
}


